import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  COLOR_CONTAINER_CONTENT_OVERVIEW_CONVERTER_TOKEN, ColorContainerContentOverviewConverter
} from './color-container-content-overview.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        colorContainerContentOverviewFeature: {
          module: () => import('./color-container-content-overview.module').then((m) => m.ColorContainerContentOverviewModule),
          cmsComponents: ['content_overview'],
        },
      },
    }),
    {
      provide: COLOR_CONTAINER_CONTENT_OVERVIEW_CONVERTER_TOKEN,
      useExisting: ColorContainerContentOverviewConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        content_overview: COLOR_CONTAINER_CONTENT_OVERVIEW_CONVERTER_TOKEN
      },
      multi: true
    },
  ],
})
export class ColorContainerContentOverviewFeatureModule {}
